/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const inventorySelectionDataSchema = z.object({
	id: z.string().uuid(),
	quantity: z.number(),
})

export type InventorySelectionDataSchema = z.infer<typeof inventorySelectionDataSchema>
